/**
 * Преобразует ссылку на видео Rutube в URL для встраивания (iframe).
 * Возвращает пустую строку, если ссылка не является ссылкой на Rutube.
 *
 * Поддерживаемые форматы:
 * - https://rutube.ru/video/<id>/
 * - https://rutube.ru/video/private/<id>/?p=<key>
 * - https://rutube.ru/play/embed/<id>
 * - rutube.ru/video/<id> (без протокола)
 */
export function toRutubeEmbedUrl(url) {
  if (!url || typeof url !== "string") {
    return "";
  }

  const value = url.trim();
  if (!value) {
    return "";
  }

  const normalized = /^https?:\/\//i.test(value)
    ? value
    : `https://${value}`;

  // Уже ссылка для встраивания.
  const embedMatch = normalized.match(
    /^https?:\/\/(?:www\.)?rutube\.ru\/(?:play|video)\/embed\/([^/?#]+)/i
  );
  if (embedMatch) {
    return `https://rutube.ru/play/embed/${embedMatch[1]}`;
  }

  // Обычная страница видео.
  const pageMatch = normalized.match(
    /^https?:\/\/(?:www\.)?rutube\.ru\/video\/(?:private\/)?([^/?#]+)/i
  );
  if (pageMatch) {
    const id = pageMatch[1];
    const pMatch = normalized.match(/[?&]p=([^&#]+)/);
    const suffix = pMatch ? `?p=${pMatch[1]}` : "";
    return `https://rutube.ru/play/embed/${id}${suffix}`;
  }

  return "";
}
